import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatDate } from '../../utils/dateUtils';

// COMPONENT
// TODO: find a better way to pass additional routing params
const DocumentsListItem = ({
    id,
    name,
    url,
    description = '',
    created,
    updated,
    backLink,
    vendor,
}) => (
    <Link
        disabled={!id}
        to={{
            pathname: `/document/${id}`,
            state: { backLink },
        }}
        className="list-group-item-action"
    >
        <div className="container">
            <div className="row">
                <div className="col-sm">
                    <strong>{name}</strong>
                </div>
                <div className="col-sm">{vendor ? 'Vendor Document' : 'Product Document'}</div>
                <div className="col-sm">{description}</div>
                <div className="col-sm">{url}</div>
                <div className="col-sm">
                    {updated || created ? formatDate(updated || created) : ''}
                </div>
            </div>
        </div>
    </Link>
);

DocumentsListItem.propTypes = {
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    id: PropTypes.string,
    vendor: PropTypes.object,
    created: PropTypes.number,
    updated: PropTypes.number,
    backLink: PropTypes.string,
    description: PropTypes.string,
};

export { DocumentsListItem };
